export default __webpack_public_path__ + "static/js_bootcamp-b5ea24d6cb656bbe56153d19b2ec0289.jpg";